import React from "react";
import "./footer.scss";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
    return (
        <footer className="footer">
            <Container>
                <Row className="footer-top gy-5">
                    <Col lg={4} md={12} className="footer-brand">
                        {/* Consistent name / address / phone — the block
                            local search and answer engines look for. */}
                        <address className="footer-nap">
                            <span className="nap-name">Book Sailing Mumbai</span>
                            <span>Gateway of India, Apollo Bandar, Colaba,<br />Mumbai, Maharashtra 400001</span>
                            <a href="tel:+917666689265">+91 76666 89265</a>
                            <span>Open daily, 7:00 AM – 10:00 PM</span>
                        </address>
                    </Col>
                    <Col lg={{ span: 2, offset: 1 }} sm={4} xs={6} className="footer-col">
                        <p className="footer-heading">Quick Links</p>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/full-fleet">Our Fleet</Link></li>
                            <li><HashLink to="/#experiences">Experiences</HashLink></li>
                            <li><Link to="/safety-guidelines">Safety</Link></li>
                            <li><HashLink to="/#contact">Contact</HashLink></li>
                        </ul>
                    </Col>
                    <Col lg={3} sm={4} xs={6} className="footer-col">
                        <p className="footer-heading">Services</p>
                        <ul>
                            <li><HashLink to="/#experiences">Luxury Yacht Charters</HashLink></li>
                            <li><HashLink to="/#experiences">Speed Boat Rentals</HashLink></li>
                            <li><HashLink to="/#experiences">Sunset Cruises</HashLink></li>
                            <li><HashLink to="/#experiences">Corporate Events</HashLink></li>
                            <li><HashLink to="/#experiences">Private Celebrations</HashLink></li>
                            <li><HashLink to="/#experiences">Wedding Proposals</HashLink></li>
                        </ul>
                    </Col>
                    <Col lg={2} sm={4} xs={12} className="footer-col">
                        <p className="footer-heading">Support</p>
                        <ul>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/terms-of-use">Terms of Use</Link></li>
                            <li><Link to="/safety-guidelines">Safety Guidelines</Link></li>
                            <li><a href="https://wa.me/917666689265" target="_blank" rel="noreferrer">WhatsApp</a></li>
                        </ul>
                    </Col>
                </Row>

                <div className="bottom-footer">
                    <p>© {new Date().getFullYear()} Book Sailing Mumbai. All rights reserved.</p>
                    <p className="footer-version">v1.1</p>
                </div>
            </Container>
        </footer>
    );
}
